import { UsernameWithBadges } from '~/app/_components/username-with-badge/username-with-badge';
import type { UserOverview } from '~/common/types/user-overview';
import { css } from '@styled-system/css';
import { Grid, Box, Image } from '@styled-system/jsx';
import backIcon from './assets/arrow-back.svg';

type Props = {
  user: UserOverview;
  onClose: () => void;
};

export const ModalHeader = ({ user, onClose }: Props) => {
  return (
    <Grid
      width="100%"
      height="45px"
      backgroundColor="white"
      lineHeight="45px"
      paddingLeft="20px"
      display={{
        lg: 'none',
        base: 'grid',
      }}
      gridTemplateColumns="repeat(3, 1fr)"
    >
      <Box onClick={onClose} marginTop="10px">
        <Image
          src={backIcon}
          width="24px"
          height="24px"
          alt="ユーザープロフィール"
        />
      </Box>
      <Box margin="auto">
        <UsernameWithBadges
          userId={user.id}
          username={user.name}
          isOfficialWriter={user.isOfficialWriter}
          isVip={user.isVip}
          styleConfigs={{
            userName: {
              fontSize: 'size_16',
              fontWeight: 'bold',
            },
          }}
          className={css({
            w: '100%',
            py: '2px',
          })}
        />
      </Box>
    </Grid>
  );
};
